var map = {
	"./bg-intro-desktop.svg": "4877",
	"./bg-intro-mobile.svg": "1a19",
	"./icon-api.svg": "f184",
	"./icon-budgeting.svg": "662b",
	"./icon-close.svg": "5c00",
	"./icon-facebook.svg": "26c8",
	"./icon-hamburger.svg": "60b9",
	"./icon-instagram.svg": "a427",
	"./icon-onboarding.svg": "b215",
	"./icon-online.svg": "7387",
	"./icon-pinterest.svg": "f46d",
	"./icon-twitter.svg": "e09c",
	"./icon-youtube.svg": "88a6",
	"./logo.svg": "88e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7675";